import { TabStyled, TabStyledContainer } from './Tabs.styles';
import { pushEvent } from '@CS/hooks';
import { memo } from 'react';

interface props {
  onSetCurrentTab?: (value: string | number) => void;
  currentTab?: string | number;
  value: string | number;
  icon: JSX.Element;
  label: string;
  id: string;
}

const Tab: React.FC<props> = ({
  onSetCurrentTab,
  currentTab,
  value,
  label,
  icon,
  id
}) => (
  <TabStyledContainer id={id}>
    <TabStyled
      onClick={() => {
        pushEvent({
          event: 'button_click',
          eventAction: label,
          eventLabel: '/fam-mode-2/customize-option'
        });

        onSetCurrentTab?.(value);
      }}
      isActive={currentTab === value}
      shuffle={value === '-1'}
    >
      {icon}
    </TabStyled>

    <label>{label}</label>
  </TabStyledContainer>
);

export default memo(Tab);
